import { all } from 'redux-saga/effects'
import watchCampaignsRequest from './watchCampaignsRequest'
import watchNewsletterSendRequest from './watchNewsletterSendRequest'
import watchCompaignUpdateRequest from './watchCompaignUpdateRequest'
import watchNewsletterGetRequest from './watchNewsletterGetRequest'
import watchNewsletterUpdateRequest from './watchNewsletterUpdateRequest'
import watchNewsletterFilterRequest from './watchNewsletterFilterRequest'

export default function* newsletterSaga() {
    yield all([
        watchCampaignsRequest(),
        watchCompaignUpdateRequest(),
        watchNewsletterSendRequest(),
        watchNewsletterGetRequest(),
        watchNewsletterUpdateRequest(),
        watchNewsletterFilterRequest()
    ])
}